module.exports = __webpack_public_path__ + "static/media/graphic-calendar.1d8cb86d.jpg";